import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Renders the primary site navigation and a collapsible mobile menu.
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/updatedLogo2.png";
import { showConferencePages } from "../../config/featureFlags";
import "./NavBar.scss";
const navLinks = [
    { label: "Home", to: "/", end: true },
    ...(showConferencePages
        ? [
            { label: "Speakers", to: "/speakers" },
            { label: "Schedule", to: "/schedule" },
        ]
        : []),
    { label: "Media", to: "/media" },
    ...(showConferencePages ? [{ label: "FAQ", to: "/faq" }] : []),
];
export function NavBar() {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => setIsOpen((prev) => !prev);
    const closeMenu = () => setIsOpen(false);
    return (_jsx("header", { className: "nav", children: _jsxs("div", { className: "nav__inner", children: [_jsxs("div", { className: "nav__brand", children: [_jsx(Link, { to: "/", className: "nav__logo", onClick: closeMenu, children: _jsx("img", { src: logo, alt: "Youth for God" }) }), _jsxs("button", { className: "nav__toggle", "aria-label": "Toggle menu", "aria-expanded": isOpen, onClick: toggleMenu, children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })] }), _jsxs("nav", { className: `nav__menu ${isOpen ? "nav__menu--open" : ""}`, children: [navLinks.map((link) => (_jsx(NavLink, { to: link.to, className: ({ isActive }) => isActive
                                ? "nav__menu-link nav__menu-link--active"
                                : "nav__menu-link", onClick: closeMenu, end: link.end, children: link.label }, link.label))), showConferencePages && (_jsx(Link, { className: "nav__cta", to: "/register", onClick: closeMenu, children: "Register" }))] })] }) }));
}
